var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 24 24",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 24h2.5C5.215 24 6 23.215 6 22.25v-.366C7.512 22.654 10.946 24 16.531 24h1.6a4.737 4.737 0 004.679-3.942l1.12-6.5A4.75 4.75 0 0019.251 8h-4.536a9.33 9.33 0 00.566-3.25c0-3.757-2.126-4.75-3.25-4.75-2.076 0-2.25 1.936-2.25 3.75 0 2.214-2.483 4.054-3.794 4.872A1.747 1.747 0 004.25 7h-2.5C.785 7 0 7.785 0 8.75v13.5C0 23.215.785 24 1.75 24zm9.531-20.25c0-2.25.381-2.25.75-2.25.704 0 1.75.866 1.75 3.25 0 2.216-.868 3.574-.874 3.584a.75.75 0 00.624 1.166h5.72a3.248 3.248 0 013.201 3.802l-1.12 6.5a3.241 3.241 0 01-3.201 2.697h-1.6C9.728 22.5 6.32 20.372 6 20.161v-9.81c.833-.442 5.281-2.972 5.281-6.601zm-9.781 5a.25.25 0 01.25-.25h2.5a.25.25 0 01.25.25v13.5c0 .136-.114.25-.25.25h-2.5a.25.25 0 01-.25-.25z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeOutline);
export default __webpack_public_path__ + "static/media/like_outline.cf0890a3.svg";
export { ForwardRef as ReactComponent };